module.exports = __webpack_public_path__ + "static/media/aws.d3ffe959.png";